import React from "react";
import moment from "moment";
import string from "../../../utils/string";
import { formattedPhone } from "../../../components/Input/TelefoneFormatado";

const AgendamentoSala = ({
  dadosAgendamento,
  sujeitoAtencao,
  utilizaTelefoneInternacional,
}) => {
  const {
    data,
    horaInicio,
    horaFim,
    sala,
    convenio,
    observacao,
    procedimentos,
  } = dadosAgendamento || {};

  const { nome, dataNascimento, contato, sexo, endereco, cpf, ocupacao } =
    sujeitoAtencao || {};

  const calculaIdade = () => {
    return moment().diff(dataNascimento, "years");
  };

  const enderecoPaciente = endereco?.nomeLogradouro
    ? `${endereco?.nomeLogradouro} - ${endereco?.numero || ""} - ${endereco?.bairro || ""}`
    : "";

  const dados = [
    [
      {
        label: "Data de agendamento:",
        value: moment(data).format("DD/MM/YYYY"),
      },
      { label: "Horário:", value: `${horaInicio} - ${horaFim}` },
    ],
    [
      { label: "Paciente:", value: nome || "" },
      {
        label: "Data de nascimento:",
        value: dataNascimento
          ? `${moment(dataNascimento).format("DD/MM/YYYY")} - ${calculaIdade(dataNascimento)} anos`
          : "",
      },
    ],
    [
      {
        label: "Telefone do paciente:",
        value: contato?.telefonePrincipal ? formattedPhone({
          utilizaTelefoneInternacional,
          telefone: contato?.telefonePrincipal,
          telefoneDDI: contato?.telefonePrincipalDDI,
        }) : "",
      },
      {
        label: "Sexo do paciente:",
        value: string.capitalize(sexo?.descricao || ""),
      },
    ],
     [
      {
        label: "CPF:",
        value: cpf ? string.cpfMask(cpf) : "",
      },
      {
        label: "Profissão:",
        value: ocupacao?.descricao ?? "",
      },
    ],
    [{ label: "Endereço do paciente:", value: enderecoPaciente }],
    [
      { label: "Agenda:", value: sala?.nome || "" },
      { label: "Convênio:", value: convenio?.descricao || "" },
    ],
    [{ label: "Observações:", value: observacao }],
  ];

  return (
    <>
      <div style={styles.tituloInfo}>Infos Paciente:</div>
      <div style={styles.container}>
        {dados.map((linha, idx) => (
          <div key={idx} style={styles.row}>
            {linha.map((item, i) => (
              <div
                key={i}
                style={{
                  ...(linha.length === 1 ? styles.fullContent : styles.content),
                  ...(i === 1 && { borderLeft: "1px solid #ccc" }),
                }}
              >
                <span style={styles.label}>{item.label}</span>
                <label>{item.value}</label>
              </div>
            ))}
          </div>
        ))}
      </div>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>#</th>
            <th style={styles.th}>Procedimento</th>
          </tr>
        </thead>
        <tbody>
          {procedimentos.map((proc, index) => (
            <tr key={index}>
              <td style={styles.td}>{index + 1}</td>
              <td style={styles.td}>{proc.nomeProcedimento}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const styles = {
  tituloInfo: {
    fontSize: 24,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ccc",
  },
  row: {
    display: "flex",
    width: "100%",
    borderBottom: "1px solid #ccc",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    padding: "4px 8px",
    gap: "4px",
  },
  fullContent: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    padding: "4px 8px",
    gap: "4px",
  },
  label: {
    fontWeight: 600,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ccc",
    marginTop: "8px",
  },
  th: {
    border: "1px solid #ccc",
    padding: "8px",
    textAlign: "left",
    backgroundColor: "#f5f5f5",
  },
  td: {
    border: "1px solid #ccc",
    padding: "8px",
  },
};

export default AgendamentoSala;
